import Input from '@blaze-react/input';
import Button from '@blaze-react/button';
import PropTypes from 'prop-types';
import { useState } from 'react';
import classnames from 'classnames';
import ModalInText from './ModalInText';
import { checkValidEmail } from '../../utils';

const FormInText = ({ subtitle, toastCaption, title, salesForceCampaignId, children }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [values, setValues] = useState({ email: '' });

  const { email } = values;

  const isEmailSet = !!checkValidEmail(email);

  const buttonClass = classnames('newsletter-signup__submit', {
    'newsletter-signup__submit--disabled': !isEmailSet
  });

  const handleChange = ({ target: { name: targetName } }, value) => {
    setValues({
      email,
      [targetName]: value
    });
  };

  return (
    <div className="newsletter-signup newsletter-signup--repeated">
      <h2 className="newsletter-signup__title">{title}</h2>

      <p className="newsletter-signup__subtitle">{subtitle}</p>

      <form className="newsletter-signup__inline-body">
        <Input
          type="text"
          name="email"
          placeholder="* Email"
          className="newsletter-signup__input"
          onChange={({ event, value }) => handleChange(event, value)}
          value={email}
        />

        <Button
          type="button"
          name="button"
          data-gtm-id="newsletter-signup"
          className={buttonClass}
          disabled={!isEmailSet}
          onClick={() => setModalOpen(true)}>
          Sign me up
        </Button>
      </form>

      {modalOpen && (
        <ModalInText
          closeModal={() => {
            setModalOpen(false);
            setValues({ email: '' });
          }}
          toastCaption={toastCaption}
          passedEmail={email}
          subtitle={subtitle}
          title={title}
          salesForceCampaignId={salesForceCampaignId}>
          {children}
        </ModalInText>
      )}
    </div>
  );
};

FormInText.propTypes = {
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  toastCaption: PropTypes.string.isRequired,
  salesForceCampaignId: PropTypes.string,
  children: PropTypes.node.isRequired
};

FormInText.defaultProps = {
  salesForceCampaignId: ''
};

export default FormInText;
